const dict = {
  languageName: '日本語',
  locale: 'ja',
  fallback: 'en',
  dir: 'ltr',

  // app
  'app.name': 'Kavykhi.Cloud',
  'app.title': (sub) => `${sub} - Kavykhi.Cloud`,

  // themes
  theme: 'テーマ',
  'theme.light': 'ライト',
  'theme.dark': 'ダーク',
  'theme.system': 'システム',
  'theme.sakura': 'サクラ',

  // generic
  email: 'メールアドレス',
  password: 'パスワード',
  ok: 'OK',
  cancel: 'キャンセル',
  retry: '再試行',
  copy: 'コピー',
  empty: '(アイテムなし)',
  loading: '読み込み中...',
  calculating: '計算中...',
  error: 'エラー',

  'in_development': 'このページは開発中です。',

  // errors
  'error.not_found': '見つかりません',
  'error.name_conflict': '名前の競合',
  'error.bad_param': '不正なパラメータ',
  'error.wrong_auth': '認証エラー',
  'error.unauthorized': '未認証',
  'error.wrong_credentials': '認証情報が正しくありません',
  'error.wrong_provider': 'プロバイダーが正しくありません',
  'error.insufficient_privileges': '権限が不足しています',
  'error.not_empty': '空ではありません',
  'error.limit_exceeded': '制限を超過しました',
  'error.already_member': 'すでにメンバーです',
  'error.not_finalized': '確定されていません',
  'error.already_finalized': 'すでに確定されています',
  'error.unexpected_patch': '予期しないパッチ',
  'error.timeout': 'タイムアウト',
  'error.not_patch': 'パッチではありません',
  'error.not_supported': 'サポートされていません',
  'error.unexpected_error': '予期しないエラー',

  // data sizes
  'datasize.B': 'B',
  'datasize.KiB': 'KiB',
  'datasize.MiB': 'MiB',
  'datasize.GiB': 'GiB',
  'datasize.TiB': 'TiB',

  // auth providers
  'auth.provider.steam': 'Steam',
  'auth.provider.github': 'GitHub',
  'auth.provider.gitlab': 'GitLab',
  'auth.provider.itch': 'itch.io',
  'auth.provider.twitch': 'Twitch',
  'auth.provider.discord': 'Discord',
  'auth.provider.google': 'Google',

  // auth dialog
  'auth.dialog.header': '認証',
  'auth.dialog.please_select': 'サインインするアカウントプロバイダーを選択してください。',
  'auth.dialog.redirecting_to': (provider) => `${provider} にリダイレクト中...`,
  'auth.dialog.remember_me': 'ログイン状態を保持する',
  'auth.dialog.log_in': 'ログイン',
  'auth.dialog.back': '戻る',
  'auth.dialog.progress_header': '認証中...',
  'auth.dialog.error.header': '認証エラー',
  'auth.dialog.error.auth_not_allowed': 'この認証情報はユーザーによって認証への使用が禁止されています。別の認証情報を使用してください。',
  'auth.dialog.error.unknown': '無効な認証パラメータです。もう一度お試しください。',
  'auth.dialog.error.back': '戻る',

  'user.profile': 'プロフィール',
  'user.logout': 'ログアウト',

  // deploy credential providers
  'deploy_credential_provider.steam': 'Steam',
  'deploy_credential_provider.itch': 'itch.io',

  'page_not_found.header': 'ページが見つかりません',
  'page_not_found.message': 'このページは存在しません。',
  'page_not_found.message2': '正確には、ここには何もありません。以下の可能性があります。',
  'page_not_found.items': [
    '以前はここに何かがありましたが、現在は削除されています。',
    '何かは存在しますが、アクセス権限がありません。',
    'または、リンクのコピー＆ペースト時に誤りがあった可能性があります。',
  ],

  'home': 'ホーム',
  'home.header.hint': 'インディー開発者向けクラウドツール',
  'home.description': 'Kavykhi.Cloud はインディーゲームの開発プラットフォームです。ダウンロード版やブラウザゲーム、プライベート/パブリックビルド、ブランチ、チーム開発など、様々な機能をサポートしています。',
  'home.auth': 'サインインまたは新規登録',
  'home.auth.hint': '新規アカウント作成、または既存アカウントへのログイン',

  'projects': 'プロジェクト',
  'projects.hint': '作業中のプロジェクト',
  'projects.project': (project) => `プロジェクト: ${project}`,
  'projects.project.hint': 'プロジェクト',
  'projects.no_projects': 'プロジェクトはまだありません。',
  'projects.new': 'プロジェクト作成',
  'projects.new_dialog.header': '新規プロジェクト',
  'projects.new_dialog.label': 'プロジェクト名',
  'projects.new_dialog.ok': 'プロジェクトを作成',
  'projects.store_page': '公開ストアページ',
  'projects.description': '説明',
  'projects.branches': 'ブランチ',
  'projects.versions': 'バージョン',
  'projects.packages': 'パッケージ',
  'projects.management': 'プロジェクト設定',
  'projects.management.breadcrumb': '設定',
  'projects.management.title': (projectTitle) => `${projectTitle} - 設定`,
  'projects.management.hint': 'プロジェクト設定',
  'projects.management.users': 'チームメンバー',
  'projects.management.users.empty': 'チームメンバーはいません。',
  'projects.management.users.role.tester': 'テスター',
  'projects.management.users.role.developer': 'デベロッパー',
  'projects.management.users.role.admin': '管理者',
  'projects.management.users.role.owner': 'オーナー',
  'projects.management.users.role.starred': 'スター付き',
  'projects.management.users.exile': 'チームから削除',
  'projects.management.users.exile.dialog.header': 'チームから削除',
  'projects.management.users.exile.dialog.message': (projectTitle, userTitle) => <>本当に {userTitle} をプロジェクト「{projectTitle}」から削除しますか？</>,
  'projects.management.users.exile.dialog.ok': 'チームから削除',
  'projects.management.invites.one_time_invite': '使い捨て招待リンク',
  'projects.management.invites.one_time_invite.header': '使い捨て招待リンク',
  'projects.management.invites.one_time_invite.message': '使い捨て招待リンク:',
  'projects.management.invites.one_time_invite.note': '24時間有効、1回のみ使用可能。',
  'projects.management.invites.new_dialog.header': '招待リンク',
  'projects.management.invites.new_dialog.expires': '有効期限:',
  'projects.management.invites.new_dialog.expires.indefinite': '(無期限)',
  'projects.management.invites.new_dialog.approval.label': 'プロジェクトへの参加:',
  'projects.management.invites.new_dialog.approval.not_approved': '管理者の承認後',
  'projects.management.invites.new_dialog.approval.approved': '即時',
  'projects.management.invites.new_dialog.seats': '参加人数制限:',
  'projects.management.invites.new_dialog.seats.no_limit': '(制限なし)',
  'projects.management.invites.new_dialog.ok': '招待リンクを作成',
  'projects.management.deploy_sites': 'デプロイ先サイト',
  'projects.management.deploy_sites.empty': 'デプロイ先サイトが登録されていません。',
  'projects.management.deploy_sites.add': 'デプロイ先サイトを追加',
  'projects.management.deploy_sites.delete': '削除',
  'projects.management.deploy_sites.delete_dialog.header': 'デプロイ先サイトの削除',
  'projects.management.deploy_sites.delete_dialog.message': (provider, site) => <>本当に {provider} のデプロイ先サイト {site} を削除しますか？</>,
  'projects.management.deploy_sites.delete_dialog.ok': 'デプロイ先サイトを削除',
  'projects.management.public_access': '公開アクセス',
  'projects.management.public_access.enable': '公開アクセスを有効化',
  'projects.management.public_access.enabled': <>公開アクセス: <strong>許可</strong></>,
  'projects.management.public_access.enabled.note': 'プロジェクトの名前と説明、および公開設定されたブランチが一般公開されます。',
  'projects.management.public_access.enable_dialog.header': '公開アクセスを有効化',
  'projects.management.public_access.enable_dialog.message': (projectTitle) => <>本当にプロジェクト「{projectTitle}」への公開アクセスを許可しますか？<br /><br />これにより、認証なしでプロジェクトの基本情報が閲覧可能になります。公開したいブランチについては、個別に公開設定を有効にする必要があります。</>,
  'projects.management.public_access.enable_dialog.ok': '公開アクセスを有効化',
  'projects.management.public_access.disable': '公開アクセスを無効化',
  'projects.management.public_access.disabled': <>公開アクセス: <strong>不許可</strong></>,
  'projects.management.public_access.disabled.note': 'プロジェクトは非公開です。プロジェクトチームのメンバーのみがアクセスできます。',
  'projects.management.public_access.disable_dialog.header': '公開アクセスを無効化',
  'projects.management.public_access.disable_dialog.message': (projectTitle) => <>本当にプロジェクト「{projectTitle}」へのすべての公開アクセスを無効にしますか？</>,
  'projects.management.public_access.disable_dialog.ok': '公開アクセスを無効化',
  'projects.management.public_access.branches': '公開ブランチ',
  'projects.management.manage': 'プロジェクト管理',
  'projects.rename': 'プロジェクト名の変更',
  'projects.rename_dialog.header': 'プロジェクト名の変更',
  'projects.rename_dialog.label': 'プロジェクト名:',
  'projects.rename_dialog.ok': 'プロジェクト名を変更',
  'projects.edit_description': '説明の編集',
  'projects.edit_description_dialog.header': 'プロジェクト説明の編集',
  'projects.edit_description_dialog.label': 'プロジェクト説明:',
  'projects.edit_description_dialog.ok': '説明を更新',
  'projects.leave': 'プロジェクトを脱退',
  'projects.leave_dialog.header': 'プロジェクトを脱退',
  'projects.leave_dialog.message': (projectTitle) => <>本当にプロジェクト「{projectTitle}」から脱退しますか？</>,
  'projects.leave_dialog.ok': 'プロジェクトを脱退',
  'projects.delete': 'プロジェクト削除',
  'projects.delete_dialog.header': 'プロジェクト削除',
  'projects.delete_dialog.message': (projectTitle) => <>本当にプロジェクト「{projectTitle}」を削除しますか？</>,
  'projects.delete_dialog.ok': 'プロジェクトを削除',

  'branches.header': (projectTitle, branchTitle) => `${projectTitle}: ${branchTitle}`,
  'branches.header.hint': 'ブランチ',
  'branches.no_branches': 'このプロジェクトにはまだブランチがありません',
  'branches.new': 'ブランチ作成',
  'branches.new_dialog.header': '新規ブランチ',
  'branches.new_dialog.label': 'ブランチ名',
  'branches.new_dialog.ok': 'ブランチを作成',
  'branches.current_version': (version) => <>現在のバージョン: {version}</>,
  'branches.current_version.packages': '現在のバージョンのパッケージ',
  'branches.no_current_version': '現在のバージョンなし',
  'branches.publish_version.new': '新しいバージョンを投稿',
  'branches.publish_version.existing': '既存のバージョンを再投稿',
  'branches.version_history': 'バージョン履歴',
  'branches.version_history.empty': 'このブランチのバージョン履歴は空です。',
  'branches.version_history.note_removal': ({ quotaCount, quotaCountText, quotaNonCurrentTime, quotaTime }) => <>現在のブランチバージョンは {quotaTime != null ? <>{quotaTime}間</> : <>無期限に</>} 保持されます。過去のバージョンは最大 {quotaNonCurrentTime} 保持されます。1ブランチあたり合計で最大 {plural(quotaCount, <>{quotaCountText} 個</>, <>{quotaCountText} 個</>)} のバージョンが保持されます。</>,
  'branches.manage': 'ブランチ管理',
  'branches.rename': 'ブランチ名の変更',
  'branches.rename_dialog.header': 'ブランチ名の変更',
  'branches.rename_dialog.label': 'ブランチ名:',
  'branches.rename_dialog.ok': 'ブランチ名を変更',
  'branches.delete': 'ブランチ削除',
  'branches.delete_dialog.header': 'ブランチ削除',
  'branches.delete_dialog.message': (branchTitle) => <>本当にブランチ「{branchTitle}」を削除しますか？</>,
  'branches.delete_dialog.ok': 'ブランチを削除',

  'versions.header': (projectTitle, versionTitle) => `${projectTitle} ${versionTitle}`,
  'versions.header.hint': 'バージョン',
  'versions.current': '現在',
  'versions.previous': '過去',
  'versions.description': '説明',
  'versions.deploy_to_site.header': 'サイトに公開',
  'versions.deploy_to_site': 'サイトに公開',
  'versions.packages': 'パッケージ',
  'versions.branches': '所属ブランチ',
  'versions.branches.publish': 'ブランチに投稿',
  'versions.branches.empty': 'このバージョンはどのブランチにも投稿されていません。',
  'versions.new_dialog.header': '新規バージョン',
  'versions.new_dialog.label_title': 'バージョン:',
  'versions.new_dialog.label_branch': 'ブランチ:',
  'versions.new_dialog.packages.header': 'パッケージ',
  'versions.new_dialog.packages.empty': 'パッケージが追加されていません。',
  'versions.new_dialog.packages.add': 'パッケージを追加',
  'versions.new_dialog.packages.add_existing': 'アップロード済みのパッケージを追加',
  'versions.new_dialog.packages.replace': 'パッケージを置換',
  'versions.new_dialog.packages.edit': 'パッケージを編集',
  'versions.new_dialog.ok': 'バージョンを作成',
  'versions.manage': 'バージョン管理',
  'versions.rename': 'バージョン名の変更',
  'versions.rename_dialog.header': 'バージョン名の変更',
  'versions.rename_dialog.label': 'バージョン名:',
  'versions.rename_dialog.ok': 'バージョン名を変更',
  'versions.edit_description': 'バージョン説明の編集',
  'versions.edit_description_dialog.header': 'バージョン説明の編集',
  'versions.edit_description_dialog.label': 'バージョン説明:',
  'versions.edit_description_dialog.ok': '説明を更新',
  'versions.delete': 'バージョン削除',
  'versions.delete_dialog.header': 'バージョン削除',
  'versions.delete_dialog.message': (versionTitle) => <>本当にバージョン「{versionTitle}」を削除しますか？</>,
  'versions.delete_dialog.ok': 'バージョンを削除',

  'versions.publish_dialog.header': 'バージョンをブランチに投稿',
  'versions.publish_dialog.message': (versionTitle) => <>バージョン「{versionTitle}」を投稿するブランチを選択してください。</>,
  'versions.publish_dialog.no_branches': 'プロジェクトにブランチがありません。',
  'versions.publish_dialog.ok': 'バージョンを投稿',

  'versions.publish_existing_dialog.header': 'バージョンを再投稿',
  'versions.publish_existing_dialog.message': '最近のバージョン:',
  'versions.publish_existing_dialog.no_versions': 'プロジェクトにバージョンがありません。',
  'versions.publish_existing_dialog.ok': 'バージョンを投稿',

  'packages.header': (projectTitle, packageTitle) => `${projectTitle}: ${packageTitle}`,
  'packages.header.hint': 'パッケージ',
  'packages.download_zip': 'ZIPとしてダウンロード',
  'packages.download_torrent': 'Torrentをダウンロード',
  'packages.total_size': (size) => <>総容量: {size}</>,
  'packages.manage': 'パッケージ管理',
  'packages.rename': 'パッケージ名の変更',
  'packages.rename_dialog.header': 'パッケージ名の変更',
  'packages.rename_dialog.label': 'パッケージ名:',
  'packages.rename_dialog.ok': 'パッケージ名を変更',
  'packages.edit_tags': 'パッケージタグの編集',
  'packages.edit_tags_dialog.header': 'パッケージタグの編集',
  'packages.edit_tags_dialog.message': (packageTitle) => <>パッケージ「{packageTitle}」のタグを指定してください:</>,
  'packages.edit_tags_dialog.ok': 'タグを設定',
  'packages.entrypoint': (entrypoint) => <>起動ファイル: {entrypoint}</>,
  'packages.entrypoint.empty': '起動ファイルが設定されていません。',
  'packages.delete': 'パッケージ削除',
  'packages.delete_dialog.header': 'パッケージ削除',
  'packages.delete_dialog.message': (packageTitle) => <>本当にパッケージ「{packageTitle}」を削除しますか？このパッケージは、追加されているすべてのバージョンから削除されます。</>,
  'packages.delete_dialog.ok': 'パッケージを削除',

  'packages.new_dialog.header': '新規パッケージ',
  'packages.new_dialog.label_title': 'タイトル:',
  'packages.new_dialog.title_placeholder': '(タグから自動生成)',
  'packages.new_dialog.tags.header': 'タグ',
  'packages.new_dialog.files.header': 'ファイル',
  'packages.new_dialog.total_size': (size, maximum) => <>総容量: {size} {maximum}</>,
  'packages.new_dialog.total_size.maximum': (size) => <>(最大 {size})</>,
  'packages.new_dialog.new_data_size': (size) => <>新規データ容量: {size}</>,
  'packages.new_dialog.checks.empty': 'ファイルが追加されていません。',
  'packages.new_dialog.checks.entrypoint.empty': '起動ファイルが設定されていません。',
  'packages.new_dialog.checks.entrypoint.missing': (entrypoint) => <>起動ファイル「{entrypoint}」が存在しません。追加し忘れていませんか？存在する起動ファイルを指定するか、未設定にしてください。</>,
  'packages.new_dialog.checks.entrypoint.missing.action': '起動ファイルを未設定にする',
  'packages.new_dialog.checks.entrypoint.ext.tag': (fileExt, tag) => <>起動ファイルの拡張子が {fileExt} です: タグ「{tag}」を推奨します。</>,
  'packages.new_dialog.checks.entrypoint.ext.tag.action': (tag) => <>タグ「{tag}」を追加</>,
  'packages.new_dialog.checks.entrypoint.ext.html': (fileExt, tag) => <>起動ファイルの拡張子が {fileExt} です: ブラウザでプレイ可能にするにはタグ「{tag}」を追加してください。</>,
  'packages.new_dialog.checks.entrypoint.ext.wrong': (fileExt) => <>起動ファイルの拡張子が {fileExt} です: 誤りはありませんか？通常、このファイル形式は起動ファイルに指定されません。</>,
  'packages.new_dialog.checks.entrypoint.ext.archive': (fileExt) => <>起動ファイルの拡張子が {fileExt} です: アーカイブファイルにまとめるのではなく、展開したファイルを直接含めることを推奨します。</>,
  'packages.new_dialog.checks.entrypoint.executable': '起動ファイルに実行可能属性が設定されていません',
  'packages.new_dialog.checks.entrypoint.executable.action': '実行可能属性を設定する',
  'packages.new_dialog.checks.single_root_dir': 'ルートに単一のフォルダを置くのではなく、ファイルを直接ルートに配置することを推奨します。',
  'packages.new_dialog.checks.single_root_dir.action': 'フォルダをその中身で置き換える',

  'packages.add_existing_dialog.header': 'パッケージを追加',
  'packages.add_existing_dialog.add': (packagesCount) => packagesCount > 0 ? `${plural(packagesCount, `${packagesCount} 個のパッケージ`, `${packagesCount} 個のパッケージ`)}を追加` : 'パッケージが選択されていません',
  'packages.add_existing_dialog.message': '最近アップロードされたパッケージ:',
  'packages.add_existing_dialog.no_packages': '最近アップロードされたパッケージはありません。',

  'packages.launch': '起動',

  'packages.install': 'インストール',
  'packages.install_dialog.header': 'インストール',
  'packages.install_dialog.workdir.label': '作業ディレクトリ:',
  'packages.install_dialog.workdir.value.new': '(新規作成)',
  'packages.install_dialog.workspace.label': '作成先フォルダ:',
  'packages.install_dialog.workspace.placeholder': '(ルートフォルダを選択)',
  'packages.install_dialog.ok': 'インストール',

  'packages.update': 'アップデート',

  'packages.upload.status.existing': '前バージョンから引き継ぎ',
  'packages.upload.status.queued': '待機中',
  'packages.upload.status.packing': 'パック中...',
  'packages.upload.status.creating': '作成中...',
  'packages.upload.status.create_retrying': '作成失敗、再試行を待機中',
  'packages.upload.status.splitting': '分割中...',
  'packages.upload.status.uploading': 'アップロード中...',
  'packages.upload.status.finalizing': '確定中...',
  'packages.upload.status.finalize_retrying': '確定失敗、再試行を待機中',
  'packages.upload.status.resolving': 'パッチ解決中...',
  'packages.upload.status.resolve_retrying': 'パッチ解決失敗、再試行を待機中...',
  'packages.upload.status.done': 'アップロード完了',
  'packages.upload.status.errored': 'エラー',

  'packages.upload.part.status.queued': '待機中',
  'packages.upload.part.status.hashing': 'ハッシュ計算中',
  'packages.upload.part.status.upload_queued': 'アップロード待機中',
  'packages.upload.part.status.uploading': 'アップロード中',
  'packages.upload.part.status.upload_retrying': 'エラー、アップロード再試行中',
  'packages.upload.part.status.upload_finalizing': 'アップロード確定中',
  'packages.upload.part.status.upload_errored': 'エラー',
  'packages.upload.part.status.done': 'アップロード完了',

  'packages.play': 'ブラウザでプレイ',
  'packages.play.reset': 'リセット',
  'packages.play.fullscreen': '全画面表示',

  'deploy_sites.add_dialog.header': 'デプロイ先サイトを追加',
  'deploy_sites.add_dialog.message': (projectTitle) => <>デプロイ認証情報を選択し、サイトのURLを入力して、プロジェクト「{projectTitle}」のデプロイ先サイトとして保存します。</>,
  'deploy_sites.add_dialog.label_credential': 'デプロイ認証情報:',
  'deploy_sites.add_dialog.select_credential': '認証情報を選択',
  'deploy_sites.add_dialog.select_credential.new': '新しい認証情報を追加...',
  'deploy_sites.add_dialog.label_select_site': 'サイトを選択:',
  'deploy_sites.add_dialog.select_credential_first': '(先に認証情報を選択してください)',
  'deploy_sites.add_dialog.select_site': '(サイトを選択)',
  'deploy_sites.add_dialog.label_enter_site': 'またはサイトURLを入力:',
  'deploy_sites.add_dialog.ok': 'サイトを追加',

  'deploy_to_site_dialog.header': 'サイトに公開',
  'deploy_to_site_dialog.message': (projectTitle, versionTitle) => <>プロジェクト「{projectTitle}」のバージョン「{versionTitle}」を公開するサイトを選択してください。</>,
  'deploy_to_site_dialog.label_site': '公開先サイト:',
  'deploy_to_site_dialog.select_site': 'サイトを選択',
  'deploy_to_site_dialog.select_site.new': '新しいデプロイ先サイトを追加...',
  'deploy_to_site_dialog.packages.message.itch': <>パッケージは <a href="https://itch.io/docs/butler/pushing.html" target="_blank">butler</a> を使用して itch.io に公開されます。チャンネル名はパッケージのタグから派生します。</>,
  'deploy_to_site_dialog.deploy': '公開',
  'deploy_to_site_dialog.close': '閉じる',
  'deploy_to_site_dialog.error.no_packages': '公開するパッケージがありません。',
  'deploy_to_site_dialog.error.non_unique_channels': ({ packagesCount, packagesCountText, channel }) => <>複数のパッケージを単一のチャンネルに公開することはできません。現在、{plural(packagesCount, <>{packagesCountText} 個のパッケージ</>, <>{packagesCountText} 個のパッケージ</>)}がチャンネル「{channel}」に公開されるよう設定されています。</>,
  'deploy_to_site_dialog.job.queued': '待機中',
  'deploy_to_site_dialog.job.downloading': 'ダウンロード中...',
  'deploy_to_site_dialog.job.unpacking': '展開中...',
  'deploy_to_site_dialog.job.uploading': '公開中...',
  'deploy_to_site_dialog.job.succeeded': '成功',
  'deploy_to_site_dialog.job.errored': 'エラー',

  'store': 'ストア',
  'store.hint': '公開プロジェクト',
  'store.project.hint': 'ストアプロジェクトページ',
  'store.project.owner': 'デベロッパー',
  'store.project.description': '説明',
  'store.project.star': 'スター',
  'store.project.starred': 'スター付き',
  'store.project.content': 'コンテンツ',
  'store.project.content.warning': 'このコンテンツはサードパーティのデベロッパーによって提供されています。',
  'store.project.branch_version': (branchTitle, versionTitle) => <>ブランチ「{branchTitle}」: バージョン {versionTitle}</>,
  'store.project.branch_version.published': (branchVersionPublished) => <>公開日: {branchVersionPublished}</>,

  'me': 'プロフィール',
  'me.hint': 'プロフィール設定と連携済みの認証情報',
  'me.rename': 'プロフィールの名前変更',
  'me.rename_dialog.header': 'プロフィールの名前変更',
  'me.rename_dialog.label_title': '名前:',
  'me.rename_dialog.ok': '名前を変更',
  'me.credentials': '認証情報',
  'me.credentials.hint.auth_allowed': 'これらの認証情報のいずれかを使用して、このアカウントにログインできます。',
  'me.credentials.hint.auth_disallowed': 'これらの認証情報はアカウントに連携されていますが、ログインには使用できません。',
  'me.credentials.empty': '認証情報がありません。',
  'me.credentials.empty.auth_allowed.warning': 'アカウントからロックアウトされる可能性があります！ログインに使用できる認証情報が連携されていません。できるだけ早くログイン可能な認証情報を連携してください。',
  'me.credentials.profile_picture.alt': (provider) => `${dict[`auth.provider.${provider}`]} プロフィール画像`,
  'me.credentials.created': (created) => <>追加日: {created}</>,
  'me.credentials.last_used': (lastUsed) => <>最終使用日: {lastUsed}</>,
  'me.credential.unlink': '連携解除',
  'me.credential.allow_auth': 'ログインを許可',
  'me.credential.disallow_auth': 'ログインを禁止',
  'me.credential.display_publicly': '公開表示する',
  'me.credential.dont_display_publicly': '公開表示しない',
  'me.credential.link': '認証情報を連携',
  'me.credential.link_dialog.header': '認証情報の連携',
  'me.credential.link_dialog.message': '連携するアカウントプロバイダーを選択してください。',
  'me.credential.unlink_dialog.header': '認証情報の連携解除',
  'me.credential.unlink_dialog.are_you_sure': (credentialProvider, credentialTitle) => <>本当に {credentialProvider} アカウント「{credentialTitle}」の Kavykhi.Cloud アカウントとの連携を解除しますか？</>,
  'me.credential.unlink_dialog.ok': '連携を解除',
  'me.sessions': 'セッション',
  'me.sessions.hint': '現在使用中のブラウザを含む、アクティブなセッションの一覧です。',
  'me.sessions.started': (started) => <>開始日時 <span class="value">{started}</span></>,
  'me.sessions.last_auth': (lastAuth) => <>アクティブ <span class="value">{lastAuth}</span></>,
  'me.sessions.current': '現在のセッション',
  'me.sessions.empty': 'セッションはありません。',
  'me.sessions.delete': '終了',
  'me.sessions.delete_dialog.header': 'セッションの終了',
  'me.sessions.delete_dialog.message': '本当にこのセッションを終了しますか？',
  'me.sessions.delete_dialog.ok': 'セッションを終了',
  'me.api_tokens': 'API トークン',
  'me.api_tokens.hint': '自動化処理などで使用する API トークンを生成できます。',
  'me.api_tokens.started': (started) => <>作成日時 <span class="value">{started}</span></>,
  'me.api_tokens.expires': (expires) => <>有効期限 <span class="value">{expires}</span></>,
  'me.api_tokens.no_expiration': '無期限',
  'me.api_tokens.empty': 'API トークンはありません。',
  'me.api_tokens.create': 'API トークンを生成',
  'me.api_tokens.create_dialog.header': 'API トークンの生成',
  'me.api_tokens.create_dialog.message': '生成された API トークン:',
  'me.api_tokens.create_dialog.note': 'このトークンは二度と表示されません。安全な場所に保存してください。',
  'me.api_tokens.delete': '削除',
  'me.api_tokens.delete_dialog.header': 'API トークンの削除',
  'me.api_tokens.delete_dialog.message': '本当にこのトークンを削除しますか？',
  'me.api_tokens.delete_dialog.ok': 'API トークンを削除',
  'me.deploy_credentials': 'デプロイ認証情報',
  'me.deploy_credentials.hint': '配信プラットフォームへのデプロイ用認証情報を追加できます。',
  'me.deploy_credentials.empty': 'デプロイ認証情報は追加されていません。',
  'me.deploy_credential.add': 'デプロイ認証情報を追加',
  'me.deploy_credential.add_dialog.header': 'デプロイ認証情報の追加',
  'me.deploy_credential.add_dialog.label_site': 'サイト:',
  'me.deploy_credential.add_dialog.label_title': 'メモ:',
  'me.deploy_credential.add_dialog.label_key': 'キー:',
  'me.deploy_credential.add_dialog.default_title': (date) => `キー ${date}`,
  'me.deploy_credential.add_dialog.ok': 'デプロイ認証情報を追加',
  'me.deploy_credential.add_dialog.hint.itch': <>itch.io の API キーを生成するには、itch.io の <a href="https://itch.io/user/settings/api-keys" target="_blank">プロフィール設定</a> にアクセスしてください。ソースが「web」または「wharf」の既存の API キーを使用できます。「Kavykhi.Cloud」ソースの API キーは機能しません。</>,
  'me.deploy_credential.add_dialog.error.not_supported': (credentialProvider) => <>現在、{credentialProvider} の認証情報の追加はサポートされていません。</>,
  'me.deploy_credential.delete': '削除',
  'me.deploy_credential.delete_dialog.header': 'デプロイ認証情報の削除',
  'me.deploy_credential.delete_dialog.message': (credentialTitle, credentialProvider) => <>本当に {credentialProvider} の認証情報「{credentialTitle}」を削除しますか？この認証情報を使用するように設定されているデプロイ先サイトもプロジェクトから削除されます。</>,
  'me.deploy_credential.delete_dialog.ok': '認証情報を削除',
  'me.public_profile': '公開プロフィール',
  'me.public_profile.public_credentials': '公開する認証情報',
  'me.public_profile.public_credentials.hint': '公開表示する認証情報を選択します。',
  'me.manage': 'アカウント管理',
  'me.delete': 'アカウント削除',
  'me.delete.dialog.header': 'アカウント削除',
  'me.delete.dialog.message': (userTitle) => <>本当に Kavykhi.Cloud アカウント「{userTitle}」を完全に削除しますか？この操作は取り消せません。</>,
  'me.delete.dialog.ok': 'アカウントを削除',

  'invite': '招待',
  'invite.hint': 'プロジェクトへの招待',
  'invite.message.already_member': (projectTitle) => <>あなたはすでにプロジェクト「{projectTitle}」のメンバーです。</>,
  'invite.message.join': (projectTitle) => <>プロジェクト「{projectTitle}」に招待されました。</>,
  'invite.join': 'プロジェクトに参加',

  'local': 'ローカルコンテンツ',
  'local.hint': 'ローカルにインストールされたコンテンツ',
  'local.workdirs': 'インストール済みパッケージ',
  'local.workdirs.empty': 'インストールされているパッケージはありません。',
  'local.workdir.action.launch': '起動',
  'local.workdir.action.repair': '修復',
  'local.workdir.action.delete': 'アンインストール',
  'local.workdir.delete_dialog.header': 'パッケージのアンインストール',
  'local.workdir.delete_dialog.message': (packageTitle) => <>本当にデバイスからパッケージ「{packageTitle}」をアンインストールしますか？</>,
  'local.workdir.delete_dialog.ok': 'アンインストール',
  'local.workspaces': 'ルートフォルダ',
  'local.app_not_detected.message': 'Kavykhi.Cloud ローカルアプリが検出されません。以下のリンクからダウンロードしてインストールしてください。すでにインストールされている場合は、アプリが起動していることを確認してください。',

  'local_app.detected': 'ローカルコンテンツ',

  'error_dialog.header': 'エラー',
  'error_dialog.messageFunc': (e) => `エラー: ${dict[`error.${e}`] ?? e}。`,

  'upload_box.choose_files': 'ファイルを選択',
  'upload_box.choose_directories': 'フォルダを選択',
  'upload_box.add.progress_dialog.header': 'ファイルを追加中',
  'upload_box.add.progress_dialog.message': 'ファイルを処理中...',
  'upload_box.delete': (itemsCount) => `${plural(itemsCount, `${itemsCount} 個のアイテム`, `${itemsCount} 個のアイテム`)}を削除`,
  'upload_box.start_upload': 'アップロード開始',
  'upload_box.drop_area.message': 'ここにファイルやフォルダをドロップ',
  'upload_box.drop_area.box_dropping_message': 'ここにドロップしてルートに配置',
  'upload_box.entry.explode_folder': 'フォルダをその中身で置き換える',
  'upload_box.entry.set_entrypoint': '起動ファイルに設定',
  'upload_box.entry.mark_executable': '実行可能に設定',
  'upload_box.entry.unmark_executable': '実行可能設定を解除',
  'upload_box.entry.remove': '削除',

  'package.tags.empty': '(タグなし)',
  'package.tag.os': 'OS',
  'package.tag.os:windows': 'Windows',
  'package.tag.os:linux': 'Linux',
  'package.tag.os:macos': 'macOS',
  'package.tag.os:android': 'Android',
  'package.tag.os:ios': 'iOS',
  'package.tag.os:web': 'Web',
  'package.tag.arch': 'アーキテクチャ',
  'package.tag.arch:x86': 'x86',
  'package.tag.arch:arm': 'ARM',
  'package.tag.bits': 'ビット数',
  'package.tag.bits:64': '64ビット',
  'package.tag.bits:32': '32ビット',
  'package.tag.packaging': 'パッケージング',
  'package.tag.packaging:installer': 'インストーラー',
  'package.tag.packaging:deb': '.deb',
  'package.tag.packaging:rpm': '.rpm',
  'package.tag.packaging:flatpak': 'Flatpak',
  'package.tag.component': 'コンポーネント',
  'package.tag.component:client': 'クライアント',
  'package.tag.component:server': 'サーバー',
  'package.tag.runtime': 'ランタイム',
  'package.tag.runtime:nodejs': 'Node.js',
  'package.tag.runtime:java': 'Java',
  'package.tag.distro': 'Linux ディストリビューション',
  'package.tag.distro:ubuntu': 'Ubuntu',
  'package.tag.distro:fedora': 'Fedora',
  'package.tag.distro:arch': 'Arch Linux',
  'package.tag.distro:nixos': 'NixOS',

  'docs': 'ドキュメント',
  'docs.page_no_language': 'この言語では利用できません',
  'docs.page_no_language.message': 'このドキュメントは他の言語で利用可能です:',
  'docs.page_no_language.other_link': (doc, lang) => <>({lang}) {doc}</>,

  'social_links.discord': 'Discord',

  'report_content': 'コンテンツを報告',
  'report_content.dialog.header': 'コンテンツを報告',
  'report_content.dialog.link': 'メールで報告を送信',
  'report_content.dialog.message': (email, link) => <>リンクをクリックして報告を送信してください:<br /><br />{link}<br /><br />または、手動で {email} 宛てにメールを送信してください。</>,
};

export default dict;

const plural = (n: number, one: string, many: string) => n == 1 ? one : many;
